// Parse an event date into display parts.
// Uses the runtime's local timezone (matches existing EventRow/EventDetailScreen behaviour).
export function formatEventDateParts(eventDate: string | Date): { dayName: string; dayNum: number; time: string } {
  const date = typeof eventDate === 'string' ? new Date(eventDate) : eventDate
  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase()
  const dayNum = date.getDate()
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  return { dayName, dayNum, time }
}
